/*
 * @Description: 
 * @Author: ke wen
 * @Date: 2021-03-01 17:21:40
 * @LastEditTime: 2021-03-01 17:23:14
 * @LastEditors: LastEditors
 * @Reference: 
 */
import request from '@/utils/request'


// 表格数据请求
export function getTableList(url, data) {
    return request({
        url: url,
        method: 'post',
        data
    })
}

// 树形下拉列表
export function getTreeList(url,data={}) {
    return request({
        url: url,
        method: 'post',
        data
    })
}

// 城市列表请求
export function getCityList(data = {}) {
    return request({
        url: '/v1/admin/base/city/list/using',
        method: 'post',
        data:{...data}
    })
}
// 查询所有启用城市列表（市场管理模块用）
export function searchCityList(data = {}) {
    return request({
        url: '/v1/admin/manager/customer/searchCityList',
        method: 'post',
        data
    })
}
// 树状查询(小区城市区域）--查询所有的有效区域列表
export function searchTreeCityAreaList(data = {}) {
    return request({
        url: '/v1/admin/base/city/searchTreeCityAreaList',
        method: 'post',
        data
    })
}
// 查询启用区县列表 - 根据城市 cityParentId 城市id
export function getAreaList(data) {
    return request({
        url: '/v1/admin/base/city/area/list/using',
        method: 'post',
        data
    })
}

//获取app列表
export function getAppList(data = {}) {
    return request({
        url: '/v1/admin/marketing/adverts/app/list',
        method: 'post',
        data
    })
}


// cmd 列表


// 查询所有命令列表
export function getCmdAllList(data = {}) {
    return request({
        url: '/v1/admin/appconfig/cmd/searchAllProductCmdList',
        method: 'post',
        data
    })
}


// 文件上传
export function upDocument(url,data) {
    return request({
        url: url,
        method: 'post',
        data,
        headers:{
            'Content-Type': 'multipart/form-data',
        }
    })
}
// 文件上传完后需要回调激活资源
export function callbackResourceFile(data) {
	return request.request({
		url: '/v1/app/resources/file/callbackResourceFile',
		method: 'post',
		data,
	})
}

// 通过文件Md5验证/获取资源信息
export function verifyObjectMd5ByPath(data) {
	return request.request({
		url: '/v1/app/resources/file/verifyObjectMd5ByPath',
		method: 'post',
		data,
	})
}

//查找图片列表
export function get(data) {
    return request({
        url: url,
        method: 'post',
        data,
        headers:{
            'Content-Type': 'multipart/form-data',
        }
    })
}

// 获取图文验证码
export function getCaptcha(data = {}) {
    return request({
        url: '/v1/admin/account/getCaptcha',
        method: 'post',
        data
    })
}
// 校验图文验证码
export function checkCaptchaCode(data) {
    return request({
        url: '/v1/admin/account/checkCaptchaCode',
        method: 'post',
        data
    })
}

/**
 * @name:创建会话
 * @description: 获取sessionKey和Server-PublicKey
 * @param {*}
 * @return {*}
 */
export function createSession(data = {}) {
    return request({
        url: '/v1/admin/session/createSession',
        method: 'post',
        data:{...data,safeType:''},
        noIntercept:true,           //不拦截该请求
    })
}


/**
 * @name:前后端握手
 * @description: 创建会话客户端使用Server-publicKey加密上传客户端公钥。服务端使用Client-PublicKey加密下发AES密钥,下发给客户端。,返回值，密码文
 * @param {*}
 * @return {*}
 */
export function handshakeClientAndServer(data) {
    return request({
        url: '/v1/admin/session/handshakeClientAndServer',
        method: 'post',
        data:{...data,safeType:'RSA'},
        noIntercept:true,           //不拦截该请求
    })
}

/**
 * @name:续约会话
 * @description: 重新获取Server-PublicKey。
 * @param {*}
 * @return {*}
 */
export function renewSession(data = {}) {
    return request({
        url: '/v1/app/session/renewSession',
        method: 'post',
        data:{...data,safeType:'AES'},
        noIntercept:true,           //不拦截该请求
    })
}

/**
 * @name:测试会话
 * @description: 测试加密会话
 * @param {*}
 * @return {*}
 */
export function testEncrypt(data = {}) {
    return request({
        url: '/v1/app/session/testEncrypt',
        method: 'post',
        data:{...data,safeType:'AES-RSA2-SIGN'}
    })
}

/**
 * @name:获取用户菜单和页面数据
 * @description: 测试加密会话
 * @param {*}
 * @return {*}
 */
 export function queryUserPowerList(data = {}) {
    return request({
        url: '/v1/admin/manager/power/user/queryUserPowerList',
        method: 'post',
        data
    })
}

// 通过Uid获取工匠信息
export function getWorkerInFo(data) {
    return request({
        url: '/v1/admin/decorate/user/artisan/getWorkerInFo',
        method: 'post',
        data
    })
}

// 获取登录验证码 - 业主
export function yzSendLoginCheckCode(data) {
    return request({
        url: '/v1/app/account/sendLoginCheckCode',
        method: 'post',
        data
    })
}
// 验证码登录注册 - 业主
export function yzCheckCodeLogin(data) {
    return request({
        url: '/v1/app/account/checkCodeLogin',
        method: 'post',
        data
    })
}
// 获取登录验证码 - 工匠
export function workerSendLoginCheckCode(data) {
    return request({
        url: '/v1/artisan/account/sendLoginCheckCode',
        method: 'post',
        data
    })
}
// 验证码登录注册 - 工匠
export function workerCheckCodeLogin(data) {
    return request({
        url: '/v1/artisan/account/checkCodeLogin',
        method: 'post',
        data
    })
}

//获取人脸认证令牌
export function faceGetToken(data) {
    return request({
        url: '/v1/artisan/base/identity/ftBasUserFaceIdentifyArt/getToken',
        method: 'post',
        data
    })
}

//活体监测
export function identityFaceAlive(data) {
    return request({
        url: '/v1/artisan/base/identity/ftBasUserFaceIdentifyArt/identityFaceAlive',
        method: 'post',
        data
    })
}

//获取用户身份认证结果信息
export function getIdentityAndFaceById(data) {
    return request({
        url: '/v1/artisan/pay/withdrawal/ftPayTeamMemberArt/getIdentityAndFaceById',
        method: 'post',
        data
    })
}



